module.exports = __webpack_public_path__ + "img/press-media_1.fbfcd981.jpg";